import { CustomButton } from "../../../../../common/components/functional/customButton/CustomButton";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Props = {
  visible: boolean;
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

const ShowAllButton = ({ visible, onClick, disabled, label }: Props) => {
  const { t } = useTranslation("common");

  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      mt="1px"
      visibility={visible ? "visible" : "hidden"}
    >
      <CustomButton
        disabled={disabled}
        sx={{
          padding: "3px",
          color: (theme) => theme.palette.primary.light,
        }}
        variant="text"
        onClick={onClick}
      >
        <Typography fontSize="14px" lineHeight="20px">
          {label || t("showAll")}
        </Typography>
      </CustomButton>
    </Box>
  );
};

export default ShowAllButton;
